// 默认金额保留小数位数
export const DEFAULT_AMOUNT_DIGIT = 2; 
